query SupportRequestMessageOriginal($id: ID!) {
  supportRequestMessageOriginal(id: $id)
}
